import React, { useState, useCallback } from 'react';
import { ProgressBreadcrumbList, ProgressBreadcrumbListTheme } from '@apply/components';

export const ProgressBreadcrumbListDemo: React.FC<{}> = ({}) => {
    const [blueVertCrumb, set_blueVertCrumb] = useState(3);
    const [whiteVertCrumb, set_whiteVertCrumb] = useState(3);
    const [redVertCrumb, set_redVertCrumb] = useState(3);
    const [grayVertCrumb, set_grayVertCrumb] = useState(3);

    const handleNextCrumbClick = (currentItem: number, maxCount: number, setUpdate: (value: number) => void) => {
        if (currentItem + 1 <= maxCount) {
            setUpdate(currentItem + 1);
        }
    };

    const handlePreviousCrumbClick = (currentItem: number, set_Update: (value: number) => void) => {
        if (currentItem - 1 > 0) {
            set_Update(currentItem - 1);
        }
    };

    const crumbClick: React.MouseEventHandler = useCallback((event) => {
        alert(event.currentTarget.id + ' clicked.');
    }, []);

    const crumbs = [
        { id: 'basicInfoCrumb', number: 1, children: 'Basic Info', handleClick: crumbClick },
        { id: 'propertyCrumb', number: 2, children: 'Property', handleClick: crumbClick },
        { id: 'budgetCrumb', number: 3, children: 'Budget', handleClick: crumbClick },
        { id: 'specsCrumb', number: 4, children: 'Specs', handleClick: crumbClick },
        { id: 'reviewCrumb', number: 5, children: 'Review', handleClick: crumbClick },
    ];

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Progress Breadcrumb Timeline :</h2>
            <br />
            <br />
            Blue Theme (Vertical) <br />
            <button
                onClick={(e) => handlePreviousCrumbClick(blueVertCrumb, set_blueVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Previous Crumb
            </button>
            <button
                onClick={(e) => handleNextCrumbClick(blueVertCrumb, crumbs.length, set_blueVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Next Crumb
            </button>
            <br />
            <br />
            <ProgressBreadcrumbList
                id='blueDemo'
                theme={ProgressBreadcrumbListTheme.Blue}
                activeCrumbNumber={blueVertCrumb}
                crumbs={crumbs}
            />
            <br />
            White Theme (Vertical) <br />
            <button
                onClick={(e) => handlePreviousCrumbClick(whiteVertCrumb, set_whiteVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Previous Crumb
            </button>
            <button
                onClick={(e) => handleNextCrumbClick(whiteVertCrumb, crumbs.length, set_whiteVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Next Crumb
            </button>
            <br />
            <br />
            <ProgressBreadcrumbList
                id='whiteDemo'
                theme={ProgressBreadcrumbListTheme.White}
                activeCrumbNumber={whiteVertCrumb}
                crumbs={crumbs}
            />
            <br />
            Red Theme (Vertical) <br />
            <button
                onClick={(e) => handlePreviousCrumbClick(redVertCrumb, set_redVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Previous Crumb
            </button>
            <button
                onClick={(e) => handleNextCrumbClick(redVertCrumb, crumbs.length, set_redVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Next Crumb
            </button>
            <br />
            <br />
            <ProgressBreadcrumbList
                id='redDemo'
                theme={ProgressBreadcrumbListTheme.Red}
                activeCrumbNumber={redVertCrumb}
                crumbs={crumbs}
            />
            <br />
            Grey Theme (Vertical) <br />
            <button
                onClick={(e) => handlePreviousCrumbClick(grayVertCrumb, set_grayVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Previous Crumb
            </button>
            <button
                onClick={(e) => handleNextCrumbClick(grayVertCrumb, crumbs.length, set_grayVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Next Crumb
            </button>
            <br />
            <br />
            <ProgressBreadcrumbList
                id='greyDemo'
                theme={ProgressBreadcrumbListTheme.Gray}
                activeCrumbNumber={grayVertCrumb}
                crumbs={crumbs}
            />
            <br />
            <hr />
            <br />
            Blue Theme (Horizontal) <br />
            <button
                onClick={(e) => handlePreviousCrumbClick(blueVertCrumb, set_blueVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Previous Crumb
            </button>
            <button
                onClick={(e) => handleNextCrumbClick(blueVertCrumb, crumbs.length, set_blueVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Next Crumb
            </button>
            <br />
            <br />
            <ProgressBreadcrumbList
                id='blueDemo'
                theme={ProgressBreadcrumbListTheme.Blue}
                activeCrumbNumber={blueVertCrumb}
                crumbs={crumbs}
                orientation='horizontal'
            />
            <br />
            White Theme (Horizontal) <br />
            <button
                onClick={(e) => handlePreviousCrumbClick(whiteVertCrumb, set_whiteVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Previous Crumb
            </button>
            <button
                onClick={(e) => handleNextCrumbClick(whiteVertCrumb, crumbs.length, set_whiteVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Next Crumb
            </button>
            <br />
            <br />
            <ProgressBreadcrumbList
                id='whiteDemo'
                theme={ProgressBreadcrumbListTheme.White}
                activeCrumbNumber={whiteVertCrumb}
                crumbs={crumbs}
                orientation='horizontal'
            />
            <br />
            Red Theme (Horizontal) <br />
            <button
                onClick={(e) => handlePreviousCrumbClick(redVertCrumb, set_redVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Previous Crumb
            </button>
            <button
                onClick={(e) => handleNextCrumbClick(redVertCrumb, crumbs.length, set_redVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Next Crumb
            </button>
            <br />
            <br />
            <ProgressBreadcrumbList
                id='redDemo'
                theme={ProgressBreadcrumbListTheme.Red}
                activeCrumbNumber={redVertCrumb}
                crumbs={crumbs}
                orientation='horizontal'
            />
            <br />
            Grey Theme (Horizontal) <br />
            <button
                onClick={(e) => handlePreviousCrumbClick(grayVertCrumb, set_grayVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Previous Crumb
            </button>
            <button
                onClick={(e) => handleNextCrumbClick(grayVertCrumb, crumbs.length, set_grayVertCrumb)}
                style={{ marginRight: '0.5rem' }}
            >
                Next Crumb
            </button>
            <br />
            <br />
            <ProgressBreadcrumbList
                id='greyDemo'
                theme={ProgressBreadcrumbListTheme.Gray}
                activeCrumbNumber={grayVertCrumb}
                crumbs={crumbs}
                orientation='horizontal'
            />
        </div>
    );
};
